import client from "./client";

export const fetchMultiTimeline = async (projectStoryId: number) => {
  const response = await client.get(`stories/${projectStoryId}/messages`);
  return response.data;
};
